import { Box, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import CustomPaper from "../../unit/CustomPaper";
import CustomTabButton from "../../unit/CustomTabButton";
import CustomTable from "../../unit/CustomTable";
import CustomTableContainer from "../../unit/CustomTableContainer";
import formatDate from "../../unit/formatDate";
import CustomDetailBox from "./CustomDetailBox";
const TableCellRight = styled(TableCell)({ textAlign: "right" });

const CustomSummaryAdviceRequestList = ({ ...props }) => {
  const userId = props.userId;
  const [activeTab, setActiveTab] = React.useState(1);
  const adviceRequest = props?.adviceRequest ? props.adviceRequest : {};
  const counselorList = props?.counselorList ? props.counselorList : {};
  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
  };
  return (
    <>
      <Box sx={{ width: "100%", pt: 0, height: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <CustomTabButton
            variant="text"
            onClick={() => handleChange(1)}
            className={activeTab === 1 ? "Mui-selected" : ""}
          >
            Current Counselor
          </CustomTabButton>
          <CustomTabButton
            variant="text"
            onClick={() => handleChange(2)}
            className={activeTab === 2 ? "Mui-selected" : ""}
          >
            Coaching History
          </CustomTabButton>
        </Box>
        <CustomDetailBox sx={{ display: activeTab === 1 ? "block" : "none" }}>
          {/* Counselor ID, Counselor Name, Counselor Agency, Applications Referred (number of applications referred by this counselor for this customer), Verifications Provided (number of verifications provided by this counselor for this customer) */}
          <CustomTableContainer commponent={CustomPaper}>
            <CustomTable
              sx={{
                minWidth: "600px",
                maxWidth: "100%",
                "& .MuiTableRow-head": {
                  border: "0px",
                },
              }}
              id="table-customer-summary-advice-request-list"
            >
              <TableHead>
                <TableRow>
                  <TableCell className="hm-table-header">
                    Counselor ID
                  </TableCell>
                  <TableCell className="hm-table-header">
                    Counselor Name
                  </TableCell>
                  <TableCell className="hm-table-header">
                    Counselor Agency
                  </TableCell>
                  <TableCell className="hm-table-header">
                    Applications Referred
                  </TableCell>
                  <TableCell className="hm-table-header">
                    Verifications Provided
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {counselorList == undefined ||
                counselorList.length == 0 ||
                counselorList == null ? (
                  <TableRow>
                    <TableCell colSpan={8}>No Counselors</TableCell>
                  </TableRow>
                ) : (
                  counselorList.map((item: any) => (
                    <TableRow key={item.iApplicationId + "_" + item.iId}>
                      <TableCell>{item.iCounselorId}</TableCell>
                      <TableCell>{item.sName}</TableCell>
                      <TableCell>{item.sAgencyName}</TableCell>
                      <TableCell>{item.appnum}</TableCell>
                      <TableCell>{item.appverifynum}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </CustomTable>
          </CustomTableContainer>
        </CustomDetailBox>
        <CustomDetailBox sx={{ display: activeTab === 2 ? "block" : "none" }}>
          <CustomTableContainer commponent={CustomPaper}>
            <CustomTable
              sx={{
                minWidth: "600px",
                maxWidth: "100%",
                "& .MuiTableRow-head": {
                  border: "0px",
                },
              }}
              id="table-customer-summary-advice-request-history-list"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ minWidth: "120px" }}
                    className="hm-table-header"
                  >
                    Date Time
                    <br /> Started
                  </TableCell>
                  <TableCell className="hm-table-header">Request ID</TableCell>
                  <TableCell className="hm-table-header">
                    Counselor ID
                  </TableCell>
                  <TableCell className="hm-table-header">
                    Counselor Name
                  </TableCell>
                  <TableCell className="hm-table-header">
                    Counselor Agency
                  </TableCell>
                  <TableCell className="hm-table-header">
                    Request Type
                  </TableCell>
                  <TableCell className="hm-table-header">Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {adviceRequest == undefined ||
                adviceRequest.length == 0 ||
                adviceRequest == null ? (
                  <TableRow>
                    <TableCell colSpan={8}>No Advice Request</TableCell>
                  </TableRow>
                ) : (
                  adviceRequest.map((item: any) => (
                    <TableRow key={item.iApplicationId + "_" + item.iId}>
                      <TableCell>{formatDate(item.created_at)}</TableCell>
                      <TableCell>{item.iId}</TableCell>
                      <TableCell>{item.expertId}</TableCell>
                      <TableCell
                        sx={{
                          minWidth: "120px",
                          wordBreak: "break-word",
                          overflowX: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "normal",
                          maxWidth: "200px",
                        }}
                      >
                        {item.expertName}
                      </TableCell>
                      <TableCell
                        sx={{
                          minWidth: "120px",
                          wordBreak: "break-word",
                          overflowX: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "normal",
                          maxWidth: "200px",
                        }}
                      >
                        {item.financialCompany}
                      </TableCell>
                      <TableCell
                        sx={{
                          minWidth: "120px",
                          wordBreak: "break-word",
                          overflowX: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "normal",
                          maxWidth: "200px",
                        }}
                      >
                        {item.sType}
                      </TableCell>
                      <TableCell>{item.statusName}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </CustomTable>
          </CustomTableContainer>
        </CustomDetailBox>
      </Box>
    </>
  );
};

export default CustomSummaryAdviceRequestList;
